import { createRouter, createWebHistory } from "vue-router";
import Login from "@/views/Login.vue";
import Customers from "@/views/CustomerList.vue";
import Dashboard from "@/views/Dashboard.vue";
// const Dashboard = Customers;

const Permissions = () => import("@/views/Permissions.vue");
const PermissionsEdit = () => import("@/views/PermissionsEdit.vue");
const AdminLogs = () => import("@/views/AdminLogs.vue");
const SendWhatsApp = () => import("@/views/Send_what’sApp.vue");
const Authentication = () => import("@/views/Authentication.vue");
const UserEngagement = () => import("@/views/UserEngagement.vue");
const TemplateManagement = () => import("@/views/TemplateManagement.vue");
const WhatsAppInbox = () => import("@/views/WhatsAppInbox.vue");

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  // ========= Dashboard =========
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },

  // ========= Customers =========
  {
    path: "/customers",
    name: "Customers",
    component: Customers,
    meta: { requiresAuth: true },
  },

  // ========= Others =========
  {
    path: "/permissions",
    name: "PermissionIndex",
    component: Permissions,
    meta: { requiresAuth: true },
  },
  {
    path: "/permissions/:id/edit",
    name: "PermissionEdit",
    component: PermissionsEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin-logs",
    name: "AdminLogs",
    component: AdminLogs,
    meta: { requiresAuth: true },
  },

  // ========= Custom pages  =========
  {
    path: "/send-whatsapp",
    name: "SendWhatsApp",
    component: SendWhatsApp,
    meta: { requiresAuth: true },
  },
  {
    path: "/whatsapp-inbox",
    name: "WhatsAppInbox",
    component: WhatsAppInbox,
    meta: { requiresAuth: true },
  },
  {
    path: "/whatsapp-templates",
    name: "TemplateManagement",
    component: TemplateManagement,
    meta: { requiresAuth: true },
  },
  {
    path: "/authentication",
    name: "Authentication",
    component: Authentication,
    meta: { requiresAuth: true },
  },
  {
    path: "/user-engagement",
    name: "UserEngagement",
    component: UserEngagement,
    meta: { requiresAuth: true },
  },

  // ========= 404 =========
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const tokenExists = !!localStorage.getItem("token");

  if (to.meta?.requiresAuth && !tokenExists) {
    const redirect = encodeURIComponent(to.fullPath || "/dashboard");
    return next(`/login?redirect=${redirect}`);
  }

  return next();
});

export default router;
